<template>
    <div class="wrapper">
        <div class="container">
            <h4>Settings</h4>
        </div>
        <div class="container card white settings" style="margin-bottom:30px">
            Here you can define different settings for Helen, such as setting color and enabling features in the app.
            <button class="btn right" value="Save" @click="save()">Save</button>
            <br><br>
             <ul class="collection">
                <li class="collection-item grey lighten-5" v-for="(setting, i) in available" :key='i'>
                    <b>{{setting.title}}</b>
                    <div class="switch right" v-if="setting.type=='boolean'">
                        <label>
                        {{setting.negative}}
                        <input type="checkbox" v-model="settings[setting.key].value" v-bind:true-value="'true'" v-bind:false-value="'false'">
                        <span class="lever"></span>
                        {{setting.positive}}
                        </label>
                    </div>
                    <div class="right" v-if="setting.type=='color'">
                        <input type="color" v-model="settings[setting.key].value">
                    </div>
                    <div class="right" v-if="setting.type=='text'">
                        <input class="collection-item-text-input" type="text" v-model="settings[setting.key].value">
                    </div>
                    <p v-if="setting.overrideAvailable">
                        <label>
                            <input type="checkbox" class="filled-in" v-model="settings[setting.key].allowOverride" />
                            <span>Allow user to override this setting from the app</span>
                        </label>
                    </p>
                </li>
            </ul>
            <Spinner v-if="loadingBatterySettings" :size="'tiny'" />
            <Modal v-if="showDeleteModal" :actions="deleteModalActions" :content="'Are you sure you want to delete this battery setting.'" :header="'Warning'"
            />
            <div class="update-setting-wrapper">
                <form v-on:submit.prevent="postUpdate">
                <h5>Update Data</h5>
                <input type="datetime-local" v-model="updateDate" placeholder="check date" required>
                <label style="margin:10px 0px;display:block">
                    <input type="checkbox" class="filled-in" v-model="updateCritical" />
                    <span>Critical</span>
                </label>
                <label style="margin:10px 0px;display:block">
                    <input type="checkbox" class="filled-in" v-model="backgroundUpdate" />
                    <span>Update in background</span>
                </label>
                <div style="margin-top:30px" class="row">
                        <form class="col s12">
                            <div class="row">
                                <div class="input-field col s12">
                                    <textarea style="border-style: solid;border-width: 1px;border-color: darkgrey;min-height: 100px;" 
                                    id="textarea2" class="materialize-textarea"  v-model="DataUpdateMessage" placeholder="Enter your update Message">      
                                    </textarea>
                                </div>
                            </div>
                        </form>
                    </div>
                <button class="btn-flat" type="submit" style="display:flex;align-items:center;justify-content:center;border:1px solid #e0e0e0;color:#888" :disabled="postingUpdate"> <Spinner :size="'tiny'" v-if="postingUpdate" /> <span v-else>Post update</span> </button>
                </form>
            </div>

            <div class="updateapk-setting-wrapper" style="margin-bottom:20px;margin-left:10px">
                <form v-on:submit.prevent="">
                    <h5>Update APK</h5>
                    <input style="margin-top:10px"  type="file" accept=".apk"  ref="apkFile"/>
                    <div>
                        <p>Latest Version</p>
                        <input type="number" v-model="LatestVersion">
                    </div>
                    <label style="margin:10px 0px;display:block">
                        <input type="checkbox" class="filled-in" v-model="apkupdateCritical"/>
                        <span>Critical</span>
                    </label>
                    
                    <div style="margin-top:30px" class="row">
                        <form class="col s12">
                            <div class="row">
                                <div class="input-field col s12">
                                    <textarea style="border-style: solid;border-width: 1px;border-color: darkgrey;min-height: 100px;" 
                                    id="textarea1" class="materialize-textarea" v-model="ApkUpdateMessage" placeholder="Enter your update Message">      
                                    </textarea>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Spinner v-if="loadingResponse" :size="'tiny'"/>
                    <button  v-if="!loadingResponse" style="height:40px;width:11em;margin-bottom:20px" @click="ApkUpdate()">Post Apk Update</button>
                </form>
            </div>
            <div class="battery-settings-wrapper" >
                <div class="battery-settings-heading">Battery Settings</div>
                <div class="battery-settings" >
                    <div class="add-new-battery-settings-wrapper">
                        <div class="add-new-battery-settings-button"  v-if="!showBatterySettingsAddNew">
                            <button class="btn" v-on:click="showBatterySettingsAddNew=!showBatterySettingsAddNew">Add Battery Setting</button>
                        </div>
                        <div class="add-new-battery-settings-form" v-if="showBatterySettingsAddNew">
                            <form v-on:submit.prevent="addNewBatterySetting">
                                <input type="text" placeholder="Notification Key" v-model="newBatteryNotificationKey" required>
                                <input type="text" placeholder="Notification Text" v-model="newBatteryNotificationValue" required>
                                <button type="submit"> Add </button>
                                <button v-on:click="showBatterySettingsAddNew=!showBatterySettingsAddNew" style="margin-left:10px"> Cancel </button>
                            </form>
                        </div>
                    </div>
                    <div class="battery-settings-content" v-if="batterySettings.length>0">
                      <div v-for="(setting, index) in batterySettings" :key="index" class="battery-setting">
                            <div class="battery-setting-display" v-if="!editingBatterySetting[index]">
                            <div class="battery-setting-head">
                            <div :id="'displayBatterySettingKey'+index">{{setting.key}}</div>
                            <div class="editing-dialog-icons">
                            <i @click='editBatterySetting(index)' class="material-icons grey-text battery-notif-edit">edit</i>
                            <i @click='confirmDeletion(setting.key)' class="material-icons grey-text battery-notif-delete">delete</i>
                            </div>
                            </div>
                            <div class="battery-setting-desc" :id="'displayBatterySettingValue'+index" >{{setting.text}}</div>
                            </div>
                            <div class="edit-battery-setting-wrapper"  v-else>
                                <div class="edit-battery-setting-icons">
                                  <i @click="hideEditingDialog(index)" class="material-icons prefix grey-text text-darken-1">undo</i>
                                  <i @click="saveBatterySetting(index)" class="material-icons prefix grey-text text-darken-1">save</i>
                                </div>
                                <div>
                                  <input type="text" readonly v-bind:value="setting.key">
                                  <input type="text" v-bind:value="setting.text" :id="'editingBatterySettingValue'+index">
                                </div>
                            </div>
                        </div>
                    </div>
               
                </div>
            </div>
            <div v-if="!loadingTextSettings">
                <div class="text-settings-head">
                    <div>Text Settings</div>
                    <div>
                        <i class="material-icons" v-if="!addingNewSettingText" @click="addingNewSettingText = true">add</i>
                        <i class="material-icons" v-else @click="addingNewSettingText = false">undo</i>
                    </div>
                </div>
                <div style="margin-bottom:20px" v-if="addingNewSettingText">
                    <form v-on:submit.prevent="addNewSettingText" style="padding:15px;border:1px solid #e0e0e0">
                    <input placeholder="Text Setting Key" required v-model="newSettingTextKey" />
                    <div style="display:flex;">
                        <input placeholder="Translation" style="margin-right:10px" v-model="newSettingTextTranslation" />
                        <select style="display:block;width:50%" v-model="newSettingTextLanguage">
                            <option v-for="(lang, index) in $store.languages" :value="lang.id" :key="index">{{lang.name}}</option>
                        </select>
                    </div>
                    <button class="btn" type="submit" :disabled="addingtextSetting">{{addSettingBtnText}}</button>
                    </form>
                </div>
                <div class="text-settings-body" >
                    <TextSettings v-for="(setting, index) in textSettings" :setting="setting" :key="index" v-if="!loadingTextSettings"></TextSettings>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.update-setting-wrapper{
    display: flex;
    flex-direction: column;
    padding: 10px 10px 30px 10px;
}
    .text-settings-head{
        padding:10px 0px;
        font-weight: 700;
        font-size: 20px;
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .text-settings-head:hover{
        cursor: pointer;
    }
    .wrapper{
        padding-top: 30px;
    }
    .container{
        margin: auto;
    }
    .settings{
        padding: 10px;
    }
    .collection-item{
        min-height: 45px;
    }
    .collection-item-text-input{
        height: 1.5rem !important;
    }
    .battery-setting-head{
         font-weight: 700;
         font-size: 13px;
         display: flex;
         justify-content: space-between;
    }
    .battery-setting{
        position: relative;
        margin:10px;
        border-bottom:1px solid #e0e0e0;
        padding-bottom:2px;
    }
    .battery-setting-desc{
        font-weight:600;
    }
    .battery-notif-delete:hover{
        color:rgba(255,0,0,0.5) !important;
        cursor: pointer;
    }
    .add-new-battery-settings-button{
        padding:5px;
        margin:5px;
    }
    .add-new-battery-settings-button button{
        padding:2px 5px;
    }
    .add-new-battery-settings-form form{
        padding:5px 10px;
        border:1px solid #e0e0e0;
    }
    .add-new-battery-settings-form form button{
        padding:2px 5px;  
    }
    .edit-battery-setting-wrapper{
        display: flex;
        flex-direction: column;
        border:1px solid #e0e0e0;
        padding:10px;
    }
    .edit-battery-setting-icons{
        text-align: right;
    }
    .battery-setting-display{
        display: flex;
        flex-direction: column;
    }
    .battery-notif-edit:hover{
        cursor: pointer;
    }
    .edit-battery-setting-icons i:hover{
        cursor: pointer;
    }
</style>
<script>
import Spinner from "../components/Spinner";
import Modal from "../components/Modal";
import TextSettings from "../components/TextSettings";

  export default {
    name: 'settings',
    components: {
            Spinner,
            Modal,
            TextSettings
        },
    data() {
      return {
        addingtextSetting:false,  
        addSettingBtnText:"Add Setting",
        newSettingTextKey:"",
        newSettingTextTranslation:"",
        newSettingTextLanguage:"",  
        addingNewSettingText:false,
        loadingTextSettings:true,
        textSettings:[],  
        showBatterySettingsAddNew:false,
        batterySettings:[],
        loadingBatterySettings:true,
        newBatteryNotificationKey:'',
        newBatteryNotificationValue:'',
        deletingBatteryKey:'',
        editingBatterySetting:{},
        showDeleteModal:false,
        updateDate:"",
        postingUpdate:false,
        updateCritical:false,
        apkupdateCritical:false,
        LatestVersion:"",
        File:'',
        loadingResponse:false,
        backgroundUpdate:false,
        ApkUpdateMessage: "",
        DataUpdateMessage:"",
        MessageStatus: true,
        TimeinSec: "",
        deleteModalActions: {
                    Yes: () => {
                         this.deleteBatterySetting(this.deletingBatteryKey);
                    },
                    No: () => {
                        this.showDeleteModal = false;
                    },
                },
        //Available user settings
        available: [{
            key: "client.limited",
            title: "Limit UI for applications acting in 'client-mode'",
            overrideAvailable: true,
            type: "boolean",
            positive: "On",
            negative: "Off"
        },{
            key: "interview.dialog",
            title: "Show dialog tab in interview",
            type: "boolean",
            positive: "On",
            negative: "Off"
        },{
            key: "interview.jumpToNavOnAnswer",
            title: "Jump to menu (quick navigation) when answer is confirmed.",
            type: "boolean",
            positive: "On",
            negative: "Off"
        },{
            key: "export.pdf",
            title: "Allow user to export summary as PDF",
            type: "boolean",
            positive: "On",
            negative: "Off"
        },{
            key: "client.pinning",
            title: "Enable locking of client device with screen pinning",
            type: "boolean",
            positive: "On",
            negative: "Off"
        },{
            key: "color.primary",
            title: "Primary color of the app",
            type: "color"
        },{
            key: "color.secondary",
            title: "Secondary color of the app",
            type: "color"
        },{
            key: "text.slogan",
            title: "Text slogan presented on setup screen",
            type: "text"
        }],
        //The default settings when no settings has been saved
        settings: {
            "client.limited":{
                value: "true",
                allowOverride: true,
            },
            "interview.dialog":{
                value: "true",
                allowOverride: false,
            },
            "export.pdf":{
                value: "true",
                allowOverride: false,
            },
            "client.pinning":{
                value: "false",
                allowOverride: false,
            },
            "interview.jumpToNavOnAnswer":{
                value: "false",
                allowOverride: false,
            },
            "color.primary":{
                value: "#1295D8",
                allowOverride: false,
            },
            "color.secondary":{
                value: "#6EB2BD",
                allowOverride: false,
            },
            "text.slogan":{
                value: "",
                allowOverride: false,
            }
        },
      }
    },
    methods: {
        TimetoSec(){
            var currentDate = new Date()
            var userDate = new Date(this.updateDate)
            var difference = (userDate - currentDate)/1000;
            this.TimeinSec = Math.round(difference)
        },
        ApkUpdate(){ 
            if(this.ApkUpdateMessage == ""){
                this.MessageStatus = false
            }
            let vm = this;
            this.loadingResponse=true;

            // to check whether the latest version enter by the user is a INT type not a decimal or float type
            var latestVisInt = !isNaN(this.LatestVersion) && (function(x) { return (x | 0) === x; })(parseFloat(this.LatestVersion))
            
            this.File = this.$refs.apkFile.files[0];

            if(latestVisInt && this.File != undefined && this.LatestVersion !='' && this.MessageStatus){
                M.toast({
                    html: "Updating Please wait"
                });
                var formData = new FormData();
                formData.append('file', this.File);
                formData.append('latestVersion',this.LatestVersion);
                formData.append('critical',this.apkupdateCritical);
                formData.append('update_message',this.ApkUpdateMessage);
                
                this.$http.post("/settings/androidversion",formData)
                .then(function(r){
                    vm.loadingResponse=false;
                    M.toast({
                    html: "Apk Update Sent"
                    });
                    vm.LatestVersion="";
                    vm.apkupdateCritical = false;
                    vm.ApkUpdateMessage = true;
                }).catch(function(r){
                    console.log(r,"error");
                    M.toast({
                    html: "Some Error Occurred"
                    });
                    vm.loadingResponse = false;
                    vm.LatestVersion="";
                    vm.apkupdateCritical=false;
                    vm.MessageStatus= true;
              });
            }
            else{
                vm.loadingResponse=false;
                vm.MessageStatus = true;
                M.toast({
                    html: "Apk Update Failed, Please check the details you entered"
                    });
                }
        },
        postUpdate(){
            this.TimetoSec();
            this.postingUpdate = true;
            var update ={
                "update_after":parseInt(this.TimeinSec),
                "critical":this.updateCritical,
                "background_update":this.backgroundUpdate,
                "update_message":this.DataUpdateMessage,
            };
            if(this.DataUpdateMessage != ""){
            this.$http.post("/settings/dataupdate", update).then(r => {
                if(r.status){
                    M.toast({"html":"Update posted."})
                }else{
                    M.toast({"html":r.error_message})
                }
                this.postingUpdate = false;
            })
            }
            else{
                this.postingUpdate = false;
                M.toast({"html":"Enter Data Update Messsage"})
            }  
        },
        addNewSettingText(){
          this.addSettingBtnText = "Adding...";
          this.addingtextSetting  = true;
          var translations = this.newSettingTextTranslation ? [{ "text":this.newSettingTextTranslation, "language":this.newSettingTextLanguage }] : [];
          var obj = {
              "key":this.newSettingTextKey,
              "phrase":{
                  "translations":translations,
                  "attachments":null
              }
          };
          var vm = this;
          this.$http.post("/settings/applicationtext", obj).then(r => {
              if(r.data.error_message == "Key already present"){
                 vm.newSettingTextKey = "";
                 M.toast({html:"Setting Key already exist!"})
              }else{
                var setting = {
                    "Key": vm.newSettingTextKey,
                    "Translation":translations
                };
                vm.textSettings.push(setting);  
                vm.newSettingTextKey = "";
                vm.newSettingTextTranslation = "";
                vm.addingNewSettingText = false;
              }
                vm.addingtextSetting  = false;
                vm.addSettingBtnText = "Add Setting";
          }).catch(r => {
                 M.toast({html:"Some error occured please try again!"});
                 vm.addingtextSetting  = false;
                 vm.addSettingBtnText = "Add Setting";
          })
        
        },
        addNewBatterySetting(){
         var formData = new FormData();
         var lang = this.$store.preferredLanguage?this.$store.preferredLanguage:'061c187a-9814-4d90-8d12-08d163275b23';
         formData.append('key',this.newBatteryNotificationKey);
         formData.append('text',this.newBatteryNotificationValue);
         formData.append('LanguageId',lang);
        this.$http
        .post("/settings/text",formData,{headers:{KeyType:'battery'}})
        .then(r=>{
           var batterySetting = {
             key:this.newBatteryNotificationKey,
             text:this.newBatteryNotificationValue
         }
         this.batterySettings.push(batterySetting);
         this.showBatterySettingsAddNew=!this.showBatterySettingsAddNew;
         this.newBatteryNotificationKey='';
         this.newBatteryNotificationValue='';
        })
        .catch(r=>{
          console.log(r);
        });
         return false;
        },
        confirmDeletion(key){
         this.deletingBatteryKey=key;
         this.showDeleteModal=true;
        },
        deleteBatterySetting(key){
         this.$http.delete("settings/text",{headers:{
            'key':key,
            'KeyType':'battery'
        }}).then(r=>{
         var removedSettingIndex = null;
         this.batterySettings.forEach((setting,index)=>{
           if(setting.key==key)
             removedSettingIndex= index;
         });
         if(removedSettingIndex!=null)
            this.batterySettings.splice(removedSettingIndex,1);
         this.showDeleteModal = false;   
        })
        .catch(r=>{
           console.log(r);
        });
        
        },
        editBatterySetting(index){
         this.$set(this.editingBatterySetting,index,true);
        },
        hideEditingDialog(index){
         this.$set(this.editingBatterySetting,index,false);
        },
        saveBatterySetting(index){
            var settingValue ="editingBatterySettingValue"+index;
            var editedText = document.getElementById(settingValue).value;
            var lang = this.$store.preferredLanguage?this.$store.preferredLanguage:'061c187a-9814-4d90-8d12-08d163275b23';
            var formData = new FormData();
            this.$http.put("settings/text",formData,{headers:{
            'KeyType':'battery',
            'text':editedText,
            'key':this.batterySettings[index].key,
            'LanguageId':lang
              }}).then(r=>{
                 this.batterySettings[index].text=editedText; 
                 this.$set(this.editingBatterySetting,index,false);
            });

        },
        save(){
            this.$http
            .post("/settings", this.settings)
            .then(r => {
                M.toast({
                    html: "Settings was saved"
                });
            })
            .catch(r => {
                console.log(r);
            });
        }
    },
    mounted() {
        this.$http
        .get("/settings")
        .then(r => {
            Object.keys(r.data).forEach(x => {
                this.settings[x] = r.data[x]
            })
        })
        .catch(r => {
            console.log(r);
        });
        var lang = this.$store.preferredLanguage?this.$store.preferredLanguage:'061c187a-9814-4d90-8d12-08d163275b23';
        this.$http.get("settings/text",{headers:{
            LanguageId:lang,
            KeyType:'battery'
        }}).then(r=>{
            this.loadingBatterySettings=false;
            if(r.data.notification && r.data.notification.length>0){
            var vm = this;
            r.data.notification.forEach(function(data,index){
                vm.$set(vm.editingBatterySetting,index,false);
            })
            this.batterySettings=r.data.notification;
            }
            }).catch(r=>{
            this.loadingBatterySettings=false;
            });
            this.$http.get("settings/applicationtext").then(r => {
                this.$store.langDict = this.$store.languages.reduce(function(obj, item){
                    obj[item.id] = item.name;
                    return obj;
                 },{});
                 if(r.data.initialized){
                     this.textSettings = r.data.data;
                 }else{
                     this.textSettings = [];
                 }
                 this.newSettingTextLanguage = this.$store.languages[0].id;
                 this.loadingTextSettings = false;
            })
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Settings.vue